import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, DateService, CalculationService } from 'app/services';
import { config } from 'app/constants';
import { itemTypeLabel } from 'app/constants/itemType.constants';
import { currency } from 'app/constants/currency.constants';
import { orderBy, sum } from 'lodash';

@Component({
  selector: 'app-customer-history-imported-dialog',
  templateUrl: './customer-history-imported-dialog.component.html',
  styleUrls: ['./customer-history-imported-dialog.component.scss'],
})
export class CustomerHistoryImportedDialogComponent implements OnInit {
  usd: string = currency.USD;
  errors: any = {};
  selectedTab: number = 3;
  isTotalDetailsVisible: boolean = false;
  customer: any;
  data: any;
  estimate: any;
  paymentHistory: any[] = [];
  isFetchingPaymentHistory: boolean = false;
  allRefunds: Number = 0;
  selectedShopSupplies: any = { name: 'Fixed', type: 'value', value: 0 };
  config: any = config;
  isFocus: boolean = false;
  selectedTax: any;
  isTaxDetailsVisible: boolean = true;
  orderTitle: string = 'Estimate';
  isEstiamteLoading: boolean = false;

  paidToDate: number = 0;
  discountValue: number = 0;
  deferredItems: any = [];
  serviceItems: any = [];
  labels = itemTypeLabel;

  constructor(
    private httpService: HTTPService,
    public helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private cdr: ChangeDetectorRef,
    public calculationService: CalculationService,
    public dateService: DateService
  ) {}

  ngOnInit() {
    const { data } = this.dynamicDialogConfig.data;
    this.getImportedRO(data);
  }

  getImportedRO(estimateId: string) {
    this.isEstiamteLoading = true;
    this.httpService.getImportedRO(estimateId).then(
      (estimate) => {
        this.customer = estimate.customer;
        this.data = estimate;
        this.data.customer = estimate.customer;
        this.estimate = estimate;

        this.estimate.services.forEach((service: any) => {
          if (service.serviceStatus === 'deferred') {
            this.deferredItems.push(service);
          } else {
            this.serviceItems.push(service);
          }
        });

        if (this.estimate.vehicleMileage && this.estimate.vehicleMileage.reading) {
          this.estimate.mileage = `${this.estimate.vehicleMileage.reading} ${this.estimate.vehicleMileage.mileageMeasuringUnit}`;
        }

        this.paymentHistory = this.estimate.payments;

        this.orderTitle = estimate.orderStatus === 'invoice' ? 'Invoice' : 'Estimate';
        this.isEstiamteLoading = false;
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  renderRemainingAmount() {
    if (this.estimate) {
      this.paidToDate = sum([
        this.calculationService.roundOff(this.estimate.card),
        this.calculationService.roundOff(this.estimate.cash),
        this.calculationService.roundOff(this.estimate.cheque),
        this.calculationService.roundOff(this.estimate.creditPayment),
        this.calculationService.roundOff(this.estimate.thirdParty),
      ]);
      const tax = this.calculationService.roundOff(this.estimate.total.taxedAmount);
      const serviceDiscount = this.calculationService.roundOff(this.estimate.total.itemDiscountedAmount);
      const { type, value } = this.estimate.total.discount;
      let totalDiscount = 0;
      if (type && value) {
        totalDiscount = type === 'percentage' ? this.estimate.total.total * (value / 100) : value;
      }
      totalDiscount = this.calculationService.roundOff(totalDiscount);

      this.discountValue = this.calculationService.roundOff(tax - serviceDiscount - totalDiscount);

      return this.estimate.total.grand - (this.estimate.cash + this.estimate.card + this.estimate.cheque);
    }
  }

  printEstimate() {
    let url;
    url = `${config.redirectUrl.repairOrderPrint}`;
    if (this.data._id) {
      url += this.data._id;
    }
    this.helperService.openPageInNewTab(
      this.helperService.constructQueryParams(url, {
        isPreview: true,
        isImport: true,
      })
    );
  }

  getPaymentHistory(estimateId: string) {
    if (this.isFetchingPaymentHistory) {
      return;
    }

    this.isFetchingPaymentHistory = true;
    this.httpService.getPaymentHistoryByOrderId(estimateId).then(
      (history: any[]) => {
        this.paymentHistory = [];
        this.setPaymentHistory(history);
        this.isFetchingPaymentHistory = false;
        this.cdr.detectChanges();
      },
      (err) => {
        // this.isFetchingPaymentHistory = false;
        this.helperService.showToaster('error', err);
      }
    );
  }

  setPaymentHistory(history: any[]) {
    if (history && history.length >= 0) {
      this.paymentHistory = [...history];
      this.allRefunds = 0;
      this.paymentHistory.forEach((payment) => {
        if (!!payment.paymentDate) {
          payment.createdAt = new Date(payment.paymentDate);
        } else {
          payment.createdAt = this.dateService.getCurrentDateTimeTz(new Date(payment.createdAt).getTime());
        }

        payment.tooltip = this.helperService.createPaymentLogTooltip(payment);

        this.allRefunds = this.allRefunds + payment.refundToDate;

        payment.refunds.map((refund) => {
          refund.tooltip = this.helperService.createRefundTooltip(refund, payment);
          refund.refundDate = this.dateService.getCurrentDateTimeTz(new Date(refund.refundDate).getTime());
          return refund;
        });

        // sort refunds
        payment.refunds = orderBy(payment.refunds, ['refundDate'], 'desc');
      });
    }
  }

  // openRepairOrderDialog(orderId) {
  //   this.appOpenRepairOrderHistoyDialog.emit(orderId);
  // }

  toggleOrderDetails(name: string, event: Event) {
    this[name] = !this[name];
  }

  handleCloseModal() {
    this.dynamicDialogRef.close();
  }
}
